module.exports = __webpack_public_path__ + "static/img/wooden-box.3426103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/wooden-box.png
// module id = WjNE
// module chunks = 2